import { Route, Routes } from "react-router";

import Tab1IconPath from "@assets/images/smart-alerts/smart-alerts-tab1.png";
import Tab2IconPath from "@assets/images/smart-alerts/smart-alerts-tab2.png";

import AlertList from "./pages/AlertList";
import IncidentList from "./pages/IncidentList";
import AlertForm from "./pages/AlertForm/AlertForm";

import ApplicationTemplate from "../dashboard/components/ApplicationTemplate/ApplicationTemplate";
import { SidePanelImage } from "../../components/styledComponents";

const tabs = [
	{ title: "Smart Alerts", icon: <SidePanelImage src={Tab1IconPath} alt="Smart Alerts" />, path: "all" },
	{ title: "Incidents", icon: <SidePanelImage src={Tab2IconPath} alt="Incidents" />, path: "incidents" }
];

const SmartAlerts = () => {
	return (
		<ApplicationTemplate menu={tabs}>
			<Routes>
				<Route path="/" exact element={<AlertList/>} />
				<Route path="/all" exact element={<AlertList />} />
				<Route path="/incidents" exact element={<IncidentList />} />
				<Route path="/add" exact element={<AlertForm />} />
				<Route path="/edit/:id" exact element={<AlertForm />} />
			</Routes>
		</ApplicationTemplate>
	);
};

export default SmartAlerts;
